import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { KwikUIButtonApiCallModule } from "./button-api-call/button-api-call.module";
import { KwikUIButtonLiveLocationModule } from "./button-live-location/button-live-location.module";
import { KwikUIInputAadhaarModule } from "./input-aadhaar/input-aadhaar.module";
import { KwikUIInputCurrencyModule } from "./input-currency/input-currency.module";
import { KwikUIInputEmailModule } from "./input-email/input-email.module";
import { KwikUIInputOtpModule } from "./input-otp/input-otp.module";
import { KwikUILabelValuePairModule } from "./label-value-pair/label-value-pair.module";
import { KwikUIMessagesModule } from "./messages/messages.module";
import { KwikUIToasterModule } from "./toaster/toaster.module";

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    KwikUIInputOtpModule,
    KwikUIInputAadhaarModule,
    KwikUIInputCurrencyModule,
    KwikUIInputEmailModule,
    KwikUIButtonApiCallModule,
    KwikUILabelValuePairModule,
    KwikUIMessagesModule,
    KwikUIButtonLiveLocationModule,
    KwikUIToasterModule
  ],
  exports: [
    KwikUIInputOtpModule,
    KwikUIInputAadhaarModule,
    KwikUIInputCurrencyModule,
    KwikUIInputEmailModule,
    KwikUIButtonApiCallModule,
    KwikUILabelValuePairModule,
    KwikUIMessagesModule,
    KwikUIButtonLiveLocationModule,
    KwikUIToasterModule
  ]
})
export class KwikUICustomModule {}
